import * as types from '../types';
import { IJobsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class JobsHttpApi extends HttpApi implements IJobsApi {
  async listJobs(page = 1, limit = 20, filters: types.JobListFilters = {}): Promise<types.PaginatedResponse<types.Job>> {
    const response = await this.http.get<types.PaginatedResponse<types.Job>>(
      '/jobs',
      { params: { page, limit, ...filters } }
    );
    return response.data;
  }

  async getJob(id: string): Promise<types.Job> {
    const response = await this.http.get<types.APIResponse<types.Job>>(`/jobs/${id}`);
    return response.data.data;
  }

  async createJob(data: types.CreateJobRequest): Promise<types.Job> {
    const response = await this.http.post<types.APIResponse<types.Job>>('/jobs', data);
    return response.data.data;
  }

  async updateJob(id: string, data: types.UpdateJobRequest): Promise<types.Job> {
    const response = await this.http.patch<types.APIResponse<types.Job>>(`/jobs/${id}`, data);
    return response.data.data;
  }

  async completeJob(id: string): Promise<types.Job> {
    const response = await this.http.patch<types.APIResponse<types.Job>>(`/jobs/${id}`, { status: types.JobStatus.COMPLETED });
    return response.data.data;
  }

  async addJobLineItem(jobId: string, data: types.AddJobLineItemRequest): Promise<types.JobLineItem> {
    const response = await this.http.post<types.APIResponse<types.JobLineItem>>(`/jobs/${jobId}/line-items`, data);
    return response.data.data;
  }

  async updateJobLineItem(jobId: string, lineId: string, data: types.UpdateJobLineItemRequest): Promise<types.JobLineItem> {
    const response = await this.http.patch<types.APIResponse<types.JobLineItem>>(`/jobs/${jobId}/line-items/${lineId}`, data);
    return response.data.data;
  }

  async removeJobLineItem(jobId: string, itemId: string): Promise<void> {
    await this.http.delete(`/jobs/${jobId}/line-items/${itemId}`);
  }
}
